import { useTranslation } from 'react-i18next';
import type { ProductInformationViewModel } from 'autogen/swagger/all';
import { Piece } from 'autogen/translation-keys/trans-website-product-priceinfo';
import type { PriceModuleProps } from './types';

// eslint-disable-next-line import/prefer-default-export
export function useMapPriceInfoToIPriceModule(
    priceInfo: ProductInformationViewModel['priceInfo'],
    showPossibleAdditionalDeliveryCost: ProductInformationViewModel['showPossibleAdditionalDeliveryCost']
): PriceModuleProps {
    const { t } = useTranslation();
    const { price, onDiscount, priceBefore, priceLabel, minimumSalesQuantity, saveLabel, recommendedPriceLabel } =
        priceInfo;

    return {
        price: minimumSalesQuantity > 1 ? `${t(Piece)} ${price}` : price,
        priceLabel,
        isOnDiscount: onDiscount,
        priceBefore,
        priceSaving: onDiscount ? saveLabel : undefined,
        showPossibleAdditionalDeliveryCost,
        recommendedPriceLabel: recommendedPriceLabel
    };
}
